<div class="location-block">
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <h1 class="card-link-location-label">{{ 'fgbcl.cardlink.offer.location.label' | translate }}</h1>
      <p class="card-link-location-instruction-text">{{ 'fgbcl.cardlink.offer.location.instruction.text' | translate }}.</p>
    </div>
    <div *ngIf="options.showMap" class="d-flex align-items-center justify-content-center location-tab">
      <div class="list-view-block" [ngClass]="{ 'active-tab': currentTab == 'list-view' }" (click)="currentTab = 'list-view'">
        <span class="icon material-icons"> format_list_bulleted </span>
        <span class="icon-label-text">{{ 'fgbcl.cardlink.offer.location.list.view.text' | translate }}</span>
      </div>
      <div *ngIf="options.showMap" class="map-view-block" [ngClass]="{ 'active-tab': currentTab == 'map_view' }" (click)="currentTab = 'map_view'">
        <span class="icon material-icons"> map </span>
        <span class="icon-label-text">{{ 'fgbcl.cardlink.offer.location.map.view.text' | translate }}</span>
      </div>
    </div>
  </div>
  <hr />
  <ng-container *ngIf="cardLinkOfferLocations$ | async as cardLinkOfferLocation">
    <ng-container *ngIf="currentTab == 'list-view'">
      <fgbcl-card-link-offer-locations-list
        [cardLinkOfferLocationDetails]="cardLinkOfferLocation?.Locations"
        [showAnimation]="options.animate"
      ></fgbcl-card-link-offer-locations-list>
    </ng-container>
    <ng-container *ngIf="currentTab == 'map_view'">
      <fgbcl-card-link-offer-locations-map
        [cardLinkOfferLocationDetails]="cardLinkOfferLocation?.Locations"
        [latitude]="latitude"
        [longitude]="longitude"
      ></fgbcl-card-link-offer-locations-map>
    </ng-container>
  </ng-container>
</div>
